// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3444":"a8c4c879","9243":"94fe1fca"}[chunkId] + ".chunk.css";
};